import { render, staticRenderFns } from "./ed-homework-teacher-section-person-course-viewer.vue?vue&type=template&id=e13d8b4e&scoped=true&"
import script from "./ed-homework-teacher-section-person-course-viewer.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-teacher-section-person-course-viewer.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-teacher-section-person-course-viewer.scss?vue&type=style&index=0&id=e13d8b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13d8b4e",
  null
  
)

export default component.exports